// extracted by mini-css-extract-plugin
export default {"drawer_setup":"AdvisoryHeader_drawer_setup__oVCGM","drawer_open_bg":"AdvisoryHeader_drawer_open_bg__SvUWz","drawer_open_icon_bg":"AdvisoryHeader_drawer_open_icon_bg__qjNNP"};